<template>
  <div style="height: 100%">
    <v-slide-group
      show-arrows
      next-icon="$chevron_right_rounded"
      prev-icon="$chevron_left_rounded"
    >
      <v-slide-item v-for="tab in tabs" :key="`${tab.id}-slide`">
        <div class="d-flex">
          <z-chip
            x-small
            :color="chipsProps.color"
            :style="{
              '--chip-color': chipsProps.color,
              '--custom-text-color': chipsProps.selectedTextColor,
            }"
            :class="{...customChipClasses}"
            :disabled="tab.disabled"
            :icon="tab.icon"
            :text="tab.text"
            :selected="tab.id === value"
            @keydown.enter="$emit('input', tab.id)"
            @click="$emit('input', tab.id)"
          ></z-chip>
        </div>
      </v-slide-item>
    </v-slide-group>
    <v-window
      class="tab-container"
      :value="value"
      @change="$emit('input', $event)"
    >
      <v-window-item
        v-for="tab of tabs.filter((tab) => !tab.disabled)"
        :key="`${tab.id}-window`"
        :value="tab.id"
      >
        <slot :name="tab.id"> </slot>
      </v-window-item>
    </v-window>
  </div>
</template>

<script>
export default {
  name: 'ZChipTabs',
  props: {
    /**
     * Abas para serem criadas.
     */
    tabs: {
      type: Array,
      required: true,
      default: () => [],
    },
    /**
     * Propriedades para customizar os chips.
     *
     * @params {Boolean} transparentChips - Se os chips devem ser transparentes.
     * @params {String} selectedTextColor - Cor do texto do chip selecionado.
     * @params {String} color - Cor do chip.
     */
    chipsProps: {
      type: Object,
      default: () => ({
        transparent: false,
        selectedTextColor: '',
        color: 'var(--black)',
      }),
    },
    /**
     * Valor da aba selecionada.
     *
     * Valor deve ser igual ao campo `id` de uma das abas.
     */
    value: {
      type: [Number, String],
      required: true,
      default: '',
    },
  },
  computed: {
    customChipClasses() {
      return {
        'mx-1': true,
        transparent: this.chipsProps.transparent,
        'custom-text-color': this.chipsProps.selectedTextColor,
      }
    },
  },
}
</script>
<style scoped lang="scss">
.tab-container {
  padding: 5px;
  height: calc(100% - 30px);

  :deep(.v-window__container) {
    height: 100%;
  }

  :deep(.v-window-item) {
    height: 100%;
  }
}

:deep(.v-slide-group__next) {
  flex: 0 1 min-content;
  min-width: min-content;
}

:deep(.v-slide-group__prev) {
  flex: 0 1 min-content;
  min-width: min-content;
}

:deep(.zoox-chip.v-chip:not(.selected)) {
  &.transparent {
    background: transparent !important;
    border: 1px solid var(--chip-color) !important;
  }
}

:deep(.zoox-chip.v-chip.selected) {
  background: var(--chip-color) !important;
  &.custom-text-color {
    .v-chip__content > * {
      color: var(--custom-text-color) !important;
    }
  }
}

:deep(.v-slide-group__content) {
  flex-wrap: wrap;
}
</style>
